import { call, put, takeLatest } from "redux-saga/effects";
import {
  updateExamRequest,
  updateExamSuccess,
  updateExamFailure,
  addExamSuccess,
  addExamFailure, addExamRequest
} from "../slices/examSlice";
import { PayloadAction } from "@reduxjs/toolkit";
import { apiRequestWithAuth } from "../utils/api";
import {ApiResponse} from "../types";

function* handleAddExam(action: PayloadAction<any>) {
  try {
    const response: ApiResponse<any> = yield call(apiRequestWithAuth, `/quiz`, "POST", action.payload);

    if (response.messageCode !== 200) throw new Error("Failed to create exam");

    yield put(addExamSuccess(response.result));
  } catch (error: any) {
    yield put(addExamFailure(error.message));
  }
}

function* handleUpdateExam(action: PayloadAction<{ examId: string; title?: string; description?: string }>) {
  try {
    const { examId, ...updatedData } = action.payload;
    const response: { messageCode: number; result: any } = yield call(
        apiRequestWithAuth,
        `/quiz/${examId}`,
        "PUT",
        updatedData
    );

    if (response.messageCode !== 200) throw new Error("Failed to update exam");

    yield put(updateExamSuccess(response.result));
  } catch (error: any) {
    yield put(updateExamFailure(error.message));
  }
}

export function* watchExamSaga() {
  yield takeLatest(addExamRequest.type, handleAddExam);
  yield takeLatest(updateExamRequest.type, handleUpdateExam);
}
